// Distingue un click intenzionale da un gesto di trascinamento confrontando
// la posizione del puntatore alla pressione (`down`) e al rilascio/click
// (`up`). Se lo spostamento supera la soglia (in px) su un asse qualsiasi è
// un drag, non un click. Usato dalla guardia anti-drag sulle icone delle
// feature IA, così un trascinamento accidentale non applica l'IA sulla foto
// selezionata. In assenza di uno dei due punti si comporta in modo sicuro
// (non è un drag) per non bloccare i click legittimi.
export const exceedsDragThreshold = (down, up, threshold) => {
  if (!down || !up) {
    return false;
  }

  return (
    Math.abs(up.x - down.x) > threshold || Math.abs(up.y - down.y) > threshold
  );
};
